import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CalendarClockIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 50, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 50) / 50}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* <rect width="50" height="50" rx="25" fill="#F8F7F5"/> */}
      <path
        d="M34.0268 18.3025C34.0268 16.9721 33.3483 15.7935 32.3215 15.106C31.7054 14.6864 30.9643 14.4453 30.1697 14.4453H29.2143V16.7935C29.2143 17.2846 28.8215 17.6864 28.3215 17.6864C27.8304 17.6864 27.4286 17.2846 27.4286 16.7935V14.4453H19.5982V16.7935C19.5982 17.2846 19.1965 17.6864 18.7054 17.6864C18.2054 17.6864 17.8125 17.2846 17.8125 16.7935V14.4453H16.8572C15.7947 14.4453 14.8304 14.8739 14.1339 15.5793C13.4286 16.2757 13 17.24 13 18.3025V18.8918H34.0268V18.3025Z"
        fill="currentColor"
      />
      <path
        d="M16.8572 34.0279H24.884C24.2054 32.8583 23.8125 31.4922 23.8125 30.0368C23.8125 25.6261 27.3929 22.0457 31.7947 22.0457C32.5715 22.0457 33.3215 22.1529 34.0268 22.3582V20.6797H13V30.1797C13 32.3047 14.7322 34.0279 16.8572 34.0279Z"
        fill="currentColor"
      />
      <path
        d="M19.5982 13.8929C19.5982 13.4018 19.1964 13 18.7054 13C18.2054 13 17.8125 13.4018 17.8125 13.8929V14.4464H19.5982V13.8929Z"
        fill="currentColor"
      />
      <path
        d="M29.2144 13.8929C29.2144 13.4018 28.8216 13 28.3216 13C27.8305 13 27.4287 13.4018 27.4287 13.8929V14.4464H29.2144V13.8929Z"
        fill="currentColor"
      />
      <path
        d="M31.7946 23.8242C28.3749 23.8242 25.5981 26.6099 25.5981 30.0296C25.5981 33.4493 28.3749 36.2261 31.7946 36.2261C35.2143 36.2261 38 33.4493 38 30.0296C38 26.6099 35.2143 23.8242 31.7946 23.8242ZM33.5536 30.9225H31.7946C31.3035 30.9225 30.9017 30.5207 30.9017 30.0296V28.1903C30.9017 27.6993 31.3035 27.2975 31.7946 27.2975C32.2946 27.2975 32.6875 27.6993 32.6875 28.1903V29.1367H33.5536C34.0446 29.1367 34.4464 29.5296 34.4464 30.0296C34.4464 30.5207 34.0446 30.9225 33.5536 30.9225Z"
        fill="currentColor"
      />
    </svg>
  )
})

CalendarClockIcon.displayName = 'CalendarClockIcon'
